import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../../../common/queryClient/getMutationFn';
import { UserDashboardSettingsUrl } from './UserDashboardSettingsUrl';

import { UserDashboardSettingsSchema } from '../schema/UserDashboardSettingsSchema';
import { UserDashboardSettingsDto } from '../schema/types';

const postUserDashboardSettings = (
  userDashboardSettings: UserDashboardSettingsDto
) =>
  apiClient
    .post<UserDashboardSettingsDto>(
      expand(UserDashboardSettingsUrl.base, {}),
      UserDashboardSettingsSchema.parse(userDashboardSettings)
    )
    .then((response) => response.data);

export const useMutateUserDashboardSettingsQuery = createApiMutationHook(
  ['user-dashboard-settings'],
  getMutationFn(postUserDashboardSettings, undefined, undefined)
);
